// React
import React from "react";
import classNames from "classnames";
// Components
import CollapsableList from "app/application/ui/sideBars/CollapsableList";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SideBar_Category.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class SideBar_Category extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (!this.props.currentUrl) {
            return React.createElement("div", null);
        }
        let isUrlMatch = this.props.currentUrl == this.props.url;
        let isUrlContains = this.props.children && this.props.currentUrl.includes(this.props.url);
        let isActiveClass = isUrlMatch || (isUrlContains && !this.props.isExpanded) ? styles.activeCategory : "";
        return (React.createElement("div", { className: classNames(styles.category, isActiveClass) },
            React.createElement("div", { className: classNames(styles.iconContainer, this.props.headingStyle, !this.props.isExpanded && styles.iconContainerClickable) },
                React.createElement("span", { className: this.props.headingIcon })),
            React.createElement("div", { className: styles.categoryContents },
                React.createElement("div", { className: classNames(styles.linkArea, this.props.headingStyle) }),
                React.createElement(CollapsableList, { url: this.props.url, heading: this.props.text, isDefaultExpanded: this.props.isExpanded, className: styles.options }, this.props.children))));
    }
}
export default SideBar_Category;
